/**
 * An Aria-based logger
 */
import * as Aria from "./Aria";
import { Event } from "./Contracts";
export default class AriaTelemetryLogger {
  constructor(tenantToken, namespace, app, session, host, release, browser, device, user) {
    if (!tenantToken) {
      throw new Error("tenantToken must not be null");
    }
    if (!namespace) {
      throw new Error("namespace must not be null");
    }
    if (!app) {
      throw new Error("app must not be null");
    }
    if (!session) {
      throw new Error("session must not be null");
    }
    Aria.AWT().initialize(tenantToken);
    this.namespace = namespace;
    this.oesApp = app;
    this.oesSession = session;
    this.oesHost = host;
    this.oesRelease = release;
    this.oesBrowser = browser;
    this.oesDevice = device;
    this.oesUser = user;
    this.sequence = 1; // Sequence starts at 1 not 0
  }
  static setApp(properties, app) {
    properties["App.Name"] = app.getName();
    properties["App.Platform"] = app.getPlatform();
    properties["App.Version"] = app.getVersion();
  }
  static setSession(properties, session) {
    properties["Session.Id"] = session.getId();
  }
  static setHost(properties, host) {
    if (host) {
      properties["Host.Id"] = host.getId();
      properties["Host.SessionId2"] = host.getSessionId();
      properties["Host.Version"] = host.getVersion();
      properties["Host.Locale"] = host.getLocale();
    }
  }
  static setEvent(properties, event) {
    properties["Event.Name"] = event.getName();
    properties["Event.Id"] = event.getId();
    properties["Event.Source"] = event.getSource();
    properties["Event.SchemaVersion"] = event.getSchemaVersion();
    properties["Event.Sequence"] = event.getSequence();
    properties["Event.SampleRate"] = event.getSampleRate();
  }
  static setRelease(properties, release) {
    if (release) {
      properties["Release.AudienceGroup"] = release.getAudienceGroup();
    }
  }
  static setBrowser(properties, browser) {
    if (browser) {
      properties["Browser.Name"] = browser.getName();
      properties["Browser.Version"] = browser.getVersion();
    }
  }
  static setDevice(properties, device) {
    if (device) {
      properties["Device.Id"] = device.getId();
    }
  }
  static setUser(properties, user) {
    if (user) {
      properties["User.PrimaryIdentityHash"] = user.getPrimaryIdentityHash();
      properties["User.PrimaryIdentitySpace"] = user.getPrimaryIdentitySpace();
      properties["User.TenantId"] = user.getTenantId();
    }
  }
  logEvent(eventName, customProperties) {
    let sampleRate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    if (!eventName) {
      throw new Error("eventName must not be null");
    }
    let oesEvent = new Event(this.namespace + AriaTelemetryLogger.EVENT_NAME_DELIMITER + eventName, this.oesSession.getId(), this.sequence, sampleRate);
    let ariaProperties = {};
    if (customProperties != null) {
      for (const key in customProperties) {
        if (customProperties.hasOwnProperty(key)) {
          ariaProperties[AriaTelemetryLogger.CUSTOM_PROPERTIES_FIELD_PREFIX + key] = customProperties[key];
        }
      }
    }
    AriaTelemetryLogger.setApp(ariaProperties, this.oesApp);
    AriaTelemetryLogger.setSession(ariaProperties, this.oesSession);
    AriaTelemetryLogger.setHost(ariaProperties, this.oesHost);
    AriaTelemetryLogger.setRelease(ariaProperties, this.oesRelease);
    AriaTelemetryLogger.setEvent(ariaProperties, oesEvent);
    AriaTelemetryLogger.setBrowser(ariaProperties, this.oesBrowser);
    AriaTelemetryLogger.setDevice(ariaProperties, this.oesDevice);
    AriaTelemetryLogger.setUser(ariaProperties, this.oesUser);
    Aria.AWT().logEvent({
      name: oesEvent.getName(),
      properties: ariaProperties
    });
    this.sequence++;
  }
}
// Event.name is set as namespace<DELIMITER>eventName
AriaTelemetryLogger.EVENT_NAME_DELIMITER = "_";
AriaTelemetryLogger.CUSTOM_PROPERTIES_FIELD_PREFIX = "Data.";